import { render } from "./TissBatchModal.vue?vue&type=template&id=2c0cddc5&scoped=true"
import script from "./TissBatchModal.vue?vue&type=script&lang=js"
export * from "./TissBatchModal.vue?vue&type=script&lang=js"

import "./TissBatchModal.vue?vue&type=style&index=0&id=2c0cddc5&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c0cddc5"]])

export default __exports__